import { render, staticRenderFns } from "./TodayUserStatisticsTable.vue?vue&type=template&id=d710e2f4&"
import script from "./TodayUserStatisticsTable.vue?vue&type=script&lang=js&"
export * from "./TodayUserStatisticsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports